import { IAffiliateSubmissions } from "@/modules/submissions/services/data/submissions/submissions.interface";
import {
  GenericProvider,
  Provider,
  EProviderFeatures,
} from "@/services/data/generic-provider";
import { baseAPIUrl } from "@/services/utils/utils";

@Provider(`${baseAPIUrl}/sdg`, [
  EProviderFeatures.LIST,
  EProviderFeatures.CREATE,
])
class UserAffiliatSDGSubmissionsProvider extends GenericProvider<IAffiliateSubmissions> {
  public async getQuestionOptions(
    optionsType: string,
    industry: string | undefined,
  ) {
    const params: Record<string, any> = { question_type: optionsType };
    if (industry) {
      params["industry"] = industry;
    }

    const url = this.buildEndPointUrl(params, "question_options");
    const request = this.httpClient.get(url);
    const result = await this.wrapRequest(request);
    return result.data;
  }

  public async submit({ draft_id }: { draft_id: number }) {
    const url = this.buildEndPointUrl({}, "affiliate-submissions");
    const request = this.httpClient.post(url, { draft_id });
    const result = await this.wrapRequest(request);
    console.log(result.data);
  }
}

export const userAffiliateSDGSubmissionsProvider =
  new UserAffiliatSDGSubmissionsProvider();
